import { Component, DestroyRef, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PasswordModule } from 'primeng/password';
import { ButtonModule } from 'primeng/button';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MessageModule } from 'primeng/message';
import { UserService } from '../../services/user.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LogService } from '../../services/log.service';

@Component({
  selector: 'app-change-password-dialog',
  imports: [
    ButtonModule,
    MessageModule,
    PasswordModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  templateUrl: './change-password-dialog.component.html',
  styleUrl: './change-password-dialog.component.scss',
})
export class ChangePasswordDialogComponent {
  private readonly destroy$ = inject(DestroyRef);
  public formSubmitted: boolean = false;
  public passwordForm: FormGroup;
  public userId: string;

  get f(): { [index: string]: any; } {
    return this.passwordForm ? this.passwordForm.controls : {};
  }

  constructor(
    public config: DynamicDialogConfig,
    private formBuilder: FormBuilder,
    private logService: LogService,
    public ref: DynamicDialogRef,
    private translate: TranslateService,
    private userService: UserService,
  ) {
    this.userId = this.config.data;
    this.passwordForm = this.formBuilder.group({
      newPass: [null, Validators.required],
      confirmPass: [null, Validators.required],
    })
  }

  public isInvalid(controlName: string): boolean {
    const control = this.f[controlName];
    return control?.invalid && (control.touched || this.formSubmitted);
  }

  public save(): void {
    this.passwordForm.markAllAsTouched();
    this.formSubmitted = true;
    if(this.passwordForm.invalid || this.f['newPass']?.value !== this.f['confirmPass']?.value) return;
    if(this.userId) {
      this.userService.changePasswordOtherUser(this.userId, this.f['newPass']?.value)
        .pipe(takeUntilDestroyed(this.destroy$))
        .subscribe({
          next: (res) => {
            this.logService.info('[Password] - changePasswordOtherUser', res, this.translate.instant('success.password-change'));
            this.ref.close();
          },
          error: (err) => {
            this.logService.error('[Password] - changePasswordOtherUser', err, this.translate.instant('error.password-change'));
          }
        });
    } else {
      this.userService.changePassword(this.f['newPass']?.value)
        .pipe(takeUntilDestroyed(this.destroy$))
        .subscribe({
          next: (res) => {
            this.logService.info('[Password] - changePassword', res, this.translate.instant('success.password-change'));
            this.ref.close();
          },
          error: (err) => {
            this.logService.error('[Password] - changePassword', err, this.translate.instant('error.password-change'));
          }
        });
    }
  }

  public cancel(): void {
    this.ref.close();
  }
}
